import { motion } from "framer-motion";
import { Users, Layers, Palette, Bell, ShieldCheck } from "lucide-react";

const STATS = [
    { icon: Users, value: "100+", label: "Happy Families" },
    { icon: Layers, value: "End-to-End", label: "Construction" },
    { icon: Palette, value: "Interior + Exterior", label: "Experts" },
    { icon: Bell, value: "Daily", label: "Site Updates" },
    { icon: ShieldCheck, value: "100%", label: "Transparent Process" },
];

export default function TrustStats() {
    return (
        <section className="relative bg-white pt-16 pb-14 md:pt-24 md:pb-20" data-testid="trust-stats-section">
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.6 }}
                    className="flex items-center gap-3 mb-10"
                >
                    <span className="w-8 h-px bg-brand-ink" />
                    <span className="text-[11px] uppercase tracking-[0.25em] text-brand-muted">Why Udaipur trusts us</span>
                </motion.div>

                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-brand-line rounded-2xl overflow-hidden border border-brand-line">
                    {STATS.map((s, i) => {
                        const Icon = s.icon;
                        return (
                            <div
                                key={s.label}
                                className="group relative bg-white p-5 md:p-7 hover:bg-brand-bone transition-colors"
                                data-testid={`trust-stat-${i}`}
                            >
                                <div className="w-9 h-9 rounded-xl bg-brand-ink text-white flex items-center justify-center mb-4 group-hover:brand-gradient transition-colors duration-300">
                                    <Icon size={16} strokeWidth={1.8} />
                                </div>
                                <div className="font-display font-bold text-xl md:text-2xl leading-none text-brand-ink tracking-tight">
                                    {s.value}
                                </div>
                                <div className="mt-1.5 text-[13px] text-brand-muted">{s.label}</div>
                                <div className="absolute top-4 right-4 text-[10px] tabular-nums text-brand-line group-hover:text-brand-orange transition-colors">
                                    0{i + 1}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
